/*
 * Copyright (c) 2019 Signum+ Software & Facility GmbH
 * Author: jahn@signum-plus.at
 */

import { ComponentFieldKey } from '../model/component.model';
import { ViewComponentKey } from '../key/view-component.key';
import { ContentData, ContentModel } from './content.component-model';

export interface ActionData extends ContentData {
  isLoading?: boolean;
}

export class ActionFieldKey {
  static readonly IS_LOADING = 'isLoading';
}

export class ActionModel extends ContentModel implements ActionData {
  static readonly KEYS = ContentModel.KEYS.concat(
    Object.keys(ActionFieldKey).map((key) => ActionFieldKey[key])
  );

  constructor(data?: ActionData, keys?: string[]) {
    super(data, keys || ActionModel.KEYS);
  }

  get isLoading(): boolean {
    return this.get(ActionFieldKey.IS_LOADING, false);
  }

  set isLoading(value: boolean) {
    this.set(ActionFieldKey.IS_LOADING, value);
  }

  protected setupValues(values: ActionData, exclusive: boolean): ActionData {
    if (exclusive && !(ComponentFieldKey.TYPE in values)) {
      values.type = ViewComponentKey.ACTION;
    }
    if (exclusive && !(ComponentFieldKey.TAB_INDEX in values)) {
      values.tabIndex = 0;
    }
    return super.setupValues(values, exclusive) as ActionData;
  }

}
